import reduce from 'lodash/reduce';
import each from 'lodash/each';
import trim from 'lodash/trim';

export const splitEmailInvitesBody = (body) => {
  if (!body) {
    return [];
  }

  return reduce(body.split('\n'), (acc, line) => {
    each(line.split(','), (rawEmail) => {
      const email = trim(rawEmail);
      if (email !== '') {
        acc.push(email);
      }
    });
    return acc;
  }, []);
};
